import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { useLocale } from "../../i18n/LocaleProvider";

const BlogCard = ({ post }) => {
  const { lang } = useLocale();
  const fm = post.frontmatter;
  return (
    <article className="card h-100">
      <div className="card-body d-flex flex-column">
        <h3 className="h5 card-title">
          <Link
            to={`/${lang}/blog/${post.slug}`}
            className="stretched-link text-decoration-none"
          >
            {fm.title}
          </Link>
        </h3>
        <div className="text-secondary small mb-2">{fm.date}</div>
        <p className="card-text text-secondary">{fm.excerpt}</p>
      </div>
    </article>
  );
};

BlogCard.propTypes = {
  post: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    frontmatter: PropTypes.shape({
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      excerpt: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default BlogCard;
